import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useDeleteHangar } from '@/hooks/useHangars'

interface DeleteHangarDialogProps {
  /** Whether dialog is open */
  open: boolean
  /** Callback when dialog open state changes */
  onOpenChange: (open: boolean) => void
  /** ID of hangar to delete */
  hangarId: string
  /** Name of hangar (for display in confirmation message) */
  hangarName: string
}

/**
 * Confirmation dialog for deleting a hangar
 * Performs soft delete (sets deleted_at timestamp)
 */
export function DeleteHangarDialog({
  open,
  onOpenChange,
  hangarId,
  hangarName,
}: DeleteHangarDialogProps) {
  const deleteMutation = useDeleteHangar()

  const handleDelete = async () => {
    try {
      await deleteMutation.mutateAsync(hangarId)
      onOpenChange(false)
    } catch {
      // Error handling is done in the mutation hook
    }
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Hangar</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete <strong>"{hangarName}"</strong>?
            <br />
            <br />
            This will also remove all associated hangar units and aircraft positions.
            This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            disabled={deleteMutation.isPending}
          >
            {deleteMutation.isPending ? 'Deleting...' : 'Delete Hangar'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
